import React from "react";
import styles from "./Instruction.module.css";
import call from "../images/callphone.svg";

const Instruction = () => {
  return (
    <section className={styles.statsSection }>
      <div className={`container ` } style={{marginLeft: "0" }}>
        <div className={`row ${styles.container}`}>
          {/* Image Column */}
          <div className={`col-lg-6 col-md-12 text-center ${styles.imgDiv}`}>
            <img src={call} alt="Mobile App" className="img-fluid" />
          </div>
          {/* Text Content Column */}
          <div className={`col-lg-5 ${styles.content}`}>
            <h6 className={styles.heading}>Build better, launch faster</h6>
            <h2 className={styles.subheading}>
              Receive clear <span className={styles.highlight}>instructions</span> <br className={styles.hideOnSmall}/> from your clients.
            </h2>
            <p className={styles.paragraph}>
              Using Iterblocks, design personalized landing pages that have a
              higher conversion rate than any standard website.
            </p>
            <div className="row">
              {/* Stat 1 */}
              <div className="col-6 text-center">
                <h4 className={styles.statNumber}>4.8K+</h4>
                <p className={styles.statText}>Startups powering</p>
              </div>
              {/* Stat 2 */}
              <div className="col-6 text-center">
                <h4 className={styles.statNumber}>8M+</h4>
                <p className={styles.statText}>Chats in last 2023</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Instruction;
